import {useEffect, useState} from "react";

import {RootDesc} from "@ui/descriptions/RootDesc";
import {RootIcon} from "@ui/icons/RootIcon";

import styles from "./styles.module.scss";

export const RatingRange = (props) => {
  const {ratingType, minLabel, maxLabel, value, onChange, disabled} = props;

  const [hoveredStar, setHoveredStar] = useState(null);
  const [rating, setRating] = useState([
    {
      id: 0,
      rate: 1,
      active: false,
    },
    {
      id: 1,
      rate: 2,
      active: false,
    },
    {
      id: 2,
      rate: 3,
      active: false,
    },
    {
      id: 3,
      rate: 4,
      active: false,
    },
    {
      id: 4,
      rate: 5,
      active: false,
    },
  ]);

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const newRating = rating.map((star) => ({
        ...star,
        active: star.rate <= value,
      }));

      setRating(newRating);
    } else {
      setRating(
        rating.map((star) => ({
          ...star,
          active: false,
        })),
      );
    }
  }, [value]);

  const handleClick = (item) => {
    const newRating = rating.map((star) => ({
      ...star,
      active: star.rate <= item.rate,
    }));

    setRating(newRating);

    if (onChange) {
      onChange(item.rate);
    }
  };

  const handleMouseEnter = (item) => {
    setHoveredStar(item.rate);
  };

  const handleMouseLeave = () => {
    setHoveredStar(null);
  };

  const getFill = (item) => {
    if (disabled) {
      return item.active ? "grey" : "greyLight";
    }

    if (item.rate <= hoveredStar) {
      return ratingType === "stars" ? "yellow" : "violet";
    }

    return item.active
      ? ratingType === "stars"
        ? "gold"
        : "violet"
      : "greyLight";
  };

  return (
    <div
      className={`${styles.stars_wrapper} ${disabled ? styles.disabled : ""}`}
    >
      {minLabel && (
        <RootDesc>
          <span>{minLabel}</span>
        </RootDesc>
      )}

      <div className={styles.stars}>
        {rating &&
          rating.map((item) => (
            <div
              style={{
                pointerEvents: disabled ? "none" : "all",
                cursor: disabled ? "default" : "pointer",
              }}
              key={item.id}
              onMouseEnter={disabled ? undefined : () => handleMouseEnter(item)}
              onMouseLeave={disabled ? undefined : handleMouseLeave}
              className={
                item.rate <= hoveredStar
                  ? `${styles.hovered} ${styles.star_container}`
                  : styles.star_container
              }
            >
              <RootIcon
                onClickIcon={disabled ? undefined : () => handleClick(item)}
                id={ratingType === "stars" ? "star" : "bullet"}
                fill={getFill(item)}
              />
            </div>
          ))}
      </div>

      {maxLabel && (
        <RootDesc>
          <span dangerouslySetInnerHTML={{__html: maxLabel}} />
        </RootDesc>
      )}
    </div>
  );
};
